import ExtensionProperty from './ExtensionProperty.vue';
export default ExtensionProperty;